import { ComposedTheme, createUseStyles } from '@glu/theming';
import { ITabsProps } from './Tabs';
import '../themeDefaults';

type TStyleProps = Pick<ITabsProps, 'left' | 'vertical'>;

const styles = ({ palette, tabs: { wrapBorder } }: ComposedTheme) => ({
  root: {
    overflowX: 'auto',
    marginBottom: 24,
  },
  tabsWrapper: {
    position: 'relative',
    '& .tab': {
      marginRight: 30,
      marginBottom: 3,
    },
    '&.vertical': {
      width: '200px',
      '&.right': {
        borderRight: `1px solid ${palette.grey.G400}`,
        margin: '0 0 0 auto',
      },
      '&.left': {
        borderLeft: `1px solid ${palette.grey.G400}`,
        margin: '0 auto 0 0',
      },
      '& .tab': {
        whiteSpace: 'normal',
        minHeight: '40px',
        margin: '0 0 8px 0',
        padding: ({ left }: TStyleProps) => (left ? '0 0 0 16px' : '0 16px 0 0'),
        textAlign: ({ left }: TStyleProps) => (left ? 'left' : 'right'),
        '&:hover': {
          backgroundColor: '#ededed',
        },
      },
    },
    whiteSpace: 'nowrap',
    ...wrapBorder,
  },

  tabs: {
    display: 'flex',
    flexDirection: ({ vertical }: TStyleProps) => (vertical ? 'column' : 'row'),
  },
});

export default createUseStyles(styles);
